<template>
    <div>
        <!-- Toast global (group="global"): lo alimenta el interceptor de httpRequest
             para errores transversales como el 403 de autorización. El group dedicado
             evita duplicados con los <Toast/> sin group de cada componente. -->
        <Toast group="global" />
        <router-view />
    </div>
</template>

<script>
export default {
    components: {
    }
}
</script>
